const router = [
  {
    path: "/productDetail",
    meta: {
      title: "productDetail"
    },
    component: resolve =>
      require(["../views/productDetail/productDetail"], resolve)
  },
  {
    path: "/orderSign",
    meta: {
      title: "报名"
    },
    component: resolve => require(["../views/orderSign/orderSign"], resolve)
  },
  {
    path: "/order",
    meta: {
      title: "订单"
    },
    component: resolve => require(["../views/order/order"], resolve)
  },
  {
    path: "/productRecord",
    meta: {
      title: "查看看货记录"
    },
    component: resolve =>
      require(["../views/productRecord/productRecord"], resolve)
  }
];

export default router;



// WEBPACK FOOTER //
// ./src/router/productDetail.js